export default class ColoringParticle extends Phaser.Particle
{
    onEmit()
    {
        this.angle = this.game.rnd.angle();
        this.game.time.events.add(Phaser.Timer.SECOND * 0.45, this.startLoop, this);
    }

    startLoop()
    {
        this.tween = this.game.add.tween(this.scale)
                     .to({x: 1.2, y:0.75}, 150, Phaser.Easing.Linear.None, false, 0, 0, true);
        this.tweenB = this.game.add.tween(this.scale)
                     .to({x:0.75, y:1.2}, 150, Phaser.Easing.Linear.None, false, 0, 0, true);
        this.tween.chain(this.tweenB);
        this.tween.repeatAll(-1);
        this.tween.start();
    }

    kill()
    {
        this.tween.stop();
        this.tween = null;
        this.tweenB = null;
        super.kill();
    }
}
